import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const InfoIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.0001 1.66663C5.39758 1.66663 1.66675 5.39746 1.66675 9.99996C1.66675 14.6025 5.39758 18.3333 10.0001 18.3333C14.6026 18.3333 18.3334 14.6025 18.3334 9.99996C18.3334 5.39746 14.6026 1.66663 10.0001 1.66663ZM10.0001 14.1666C9.54008 14.1666 9.16675 13.7933 9.16675 13.3333V9.99996C9.16675 9.53996 9.54008 9.16663 10.0001 9.16663C10.4601 9.16663 10.8334 9.53996 10.8334 9.99996V13.3333C10.8334 13.7933 10.4601 14.1666 10.0001 14.1666ZM10.4167 7.49996H9.58342C9.35342 7.49996 9.16675 7.31329 9.16675 7.08329V6.24996C9.16675 6.01996 9.35342 5.83329 9.58342 5.83329H10.4167C10.6467 5.83329 10.8334 6.01996 10.8334 6.24996V7.08329C10.8334 7.31329 10.6467 7.49996 10.4167 7.49996Z",
      fill: "currentColor"
    }
  ) }),
  "Info"
);
export {
  InfoIcon
};
